export default "__VITE_ASSET__24m1DpBJ__"